// extracted by mini-css-extract-plugin
export default {"container":"WelcomeDashboard_container__9o4km","fadeUp":"WelcomeDashboard_fadeUp__JopEP"};